import React from "react";
//#region types
import { TableAsyncProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import TableAsyncInner from "./tableAsyncInner";
import { ErrorBoundary } from "components/error";
//#endregion

function TableAsync<RowType extends Record<string, any>>(props: React.PropsWithChildren<TableAsyncProps<RowType>>) {
  return (
    <ErrorBoundary>
      <TableAsyncInner {...props} />
    </ErrorBoundary>
  );
}

export default TableAsync;
